import { render, staticRenderFns } from "./ReferralSelectorOption.vue?vue&type=template&id=0f8eac80&scoped=true&"
import script from "./ReferralSelectorOption.vue?vue&type=script&lang=js&"
export * from "./ReferralSelectorOption.vue?vue&type=script&lang=js&"
import style0 from "./ReferralSelectorOption.vue?vue&type=style&index=0&id=0f8eac80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8eac80",
  null
  
)

export default component.exports